import { useMemo, useState } from 'react';
import { Card, Table, Button, Badge, Form } from 'react-bootstrap';
import { Link, useSearchParams } from 'react-router-dom';
import { reposService } from '@/services/api';
import { useAsync } from '@/common/hooks/use-async';
import { AsyncBoundary } from '@/common/components/async-boundary';

export default function WorkspaceRepos() {
  const [params] = useSearchParams();
  const workspace = params.get('workspace') ?? '';
  const { data, loading, error } = useAsync(
    () => reposService.listBitbucketRepos(workspace),
    [workspace],
  );
  const [filter, setFilter] = useState('');

  const all = data?.items ?? [];
  const items = useMemo(() => {
    const q = filter.trim().toLowerCase();
    if (!q) return all;
    return all.filter((r) => (r.slug || '').toLowerCase().includes(q) || (r.name || '').toLowerCase().includes(q));
  }, [all, filter]);

  return (
    <Card>
      <Card.Header>
        Repos in <code>{workspace}</code> — <Link to="/onboarding">change workspace</Link>
      </Card.Header>
      <Card.Body>
        <Form.Control
          className="mb-3"
          placeholder="Filter repos…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{ maxWidth: 360 }}
        />
        <AsyncBoundary loading={loading} error={error}>
          <Table hover responsive>
            <thead>
              <tr><th>Repo</th><th>Main branch</th><th>Status</th><th /></tr>
            </thead>
            <tbody>
              {items.map((r) => (
                <tr key={r.slug}>
                  <td>{r.name || r.slug} <span className="text-muted">({r.slug})</span></td>
                  <td>{r.mainBranch ?? '-'}</td>
                  <td>{r.managed ? <Badge bg="success">managed</Badge> : <Badge bg="secondary">not managed</Badge>}</td>
                  <td className="text-end">
                    {r.managed ? (
                      <Link to={`/repos/detail?repo=${encodeURIComponent(`${workspace}/${r.slug}`)}`}>Configure</Link>
                    ) : (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        as={Link as any}
                        to={`/onboarding/wizard?workspace=${encodeURIComponent(workspace)}&repo=${encodeURIComponent(r.slug)}${r.mainBranch ? `&mainBranch=${encodeURIComponent(r.mainBranch)}` : ''}`}
                      >
                        ＋ Onboard
                      </Button>
                    )}
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={4} className="text-muted">No repos.</td></tr>}
            </tbody>
          </Table>
        </AsyncBoundary>
      </Card.Body>
    </Card>
  );
}
